import React, { useState, useEffect } from 'react';

import inMemoryJwt from '../../core/services/inMemoryJwtService';
import { ajaxLogout, ajaxValidateToken } from '../../core/services/authenticationService';
import SignIn from './loginComponent';
import Navbar from '../header';
import Applications from '../authorizedPages/applications';


const Validator = () => {
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [isUserLogged, setIsUserLogged] = useState(false);

    useEffect(() => {
        if (inMemoryJwt.getToken()) {
            setIsUserLogged(true);
        }
    }, []);


    const checkTokenValidityHandler = (event: any) => {
        event.preventDefault();

        ajaxValidateToken()
            .then(() => {
                setShowSuccessMsg(true);

                setTimeout(() => {
                    setShowSuccessMsg(false);
                }, 3000);
            }).catch(err => {
                console.error(err);
                setShowErrorMsg(true);

                setTimeout(() => {
                    setShowErrorMsg(false);
                }, 3000);
            });
    };

    return (
        <div className="Validator">
            {/* <button type="button" onClick={checkTokenValidityHandler}>Check token validity</button> */}

            {
                isUserLogged ?
                    <>
                        <Navbar setIsUserLogged={setIsUserLogged} />
                        <Applications/>
                    </>
                    :
                    <SignIn setIsUserLogged={setIsUserLogged} />
            }

            {/* {
                showSuccessMsg ?
                    <div>Success: Token is valid</div>
                    : null
            }

            {
                showErrorMsg ?
                    <div>Error: Token is invalid</div>
                    : null
            } */}
        </div>
    );
}

export default Validator;